import { render, staticRenderFns } from "./PowerRange.vue?vue&type=template&id=f4fb2a1a&scoped=true&"
import script from "./PowerRange.vue?vue&type=script&lang=js&"
export * from "./PowerRange.vue?vue&type=script&lang=js&"
import style0 from "./PowerRange.vue?vue&type=style&index=0&id=f4fb2a1a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fb2a1a",
  null
  
)

export default component.exports